// Analitik Plan 4 (spec §6.3) — bulgu kuralı eşikleri ↔ PerformanceSettings.InsightRulesJson. Arayüz yüzde/gün/kişi
// sayısıyla çalışır; sunucu oranları (0–1, katsayı) bekler ve kanonik biçime getirir (varsayılana eşitse null saklar,
// yalnız DEĞER değişince bulgu sürümünü artırır).
export const INSIGHT_RULE_DEFAULTS = {
  overdueTaskSharePct: 50,
  overdueAssigneeSharePct: 20,
  overdueMinTasks: 5,
  slowdownIncreasePct: 50,
  slowdownWindowDays: 14,
  slowdownMinN: 20,
  reviewScoreBelow: 60,
  // Faz 2 (spec §4) — yük birikimi.
  pileupWindowDays: 7,
  pileupMinTasks: 10,
  pileupUntouchedSharePct: 60,
  pileupRedSharePct: 80,
  // P7a (analiz §26) — AI kuralları: AI02 hedef düşüşü, AI03 öz–yönetici farkı, AI04 puanlama sapması, AI06 süren yetkinlik açığı.
  goalDeclinePp: 10,
  goalDeclineMinN: 20,
  goalDeclineMinCoveragePct: 80,
  reviewGapT: 1,
  deviationAbs: 0.5,
  deviationManagerMinN: 10,
  deviationPeerMinN: 20,
  deviationMinCoveragePct: 80,
  competencyGapPeriods: 3,
};

const num = (v, fallback) => (v == null || Number.isNaN(Number(v)) ? fallback : Number(v));
const round = (v) => Math.round(v * 10000) / 10000;

export function insightRulesFromJson(json) {
  let parsed = {};
  if (json) {
    try { parsed = JSON.parse(json) || {}; } catch { parsed = {}; }
  }
  const d = INSIGHT_RULE_DEFAULTS;
  return {
    overdueTaskSharePct: parsed.overdueTaskShare != null ? round(num(parsed.overdueTaskShare, 0.5) * 100) : d.overdueTaskSharePct,
    overdueAssigneeSharePct: parsed.overdueAssigneeShare != null ? round(num(parsed.overdueAssigneeShare, 0.2) * 100) : d.overdueAssigneeSharePct,
    overdueMinTasks: num(parsed.overdueMinTasks, d.overdueMinTasks),
    slowdownIncreasePct: parsed.slowdownRatio != null ? round((num(parsed.slowdownRatio, 1.5) - 1) * 100) : d.slowdownIncreasePct,
    slowdownWindowDays: num(parsed.slowdownWindowDays, d.slowdownWindowDays),
    slowdownMinN: num(parsed.slowdownMinN, d.slowdownMinN),
    reviewScoreBelow: num(parsed.reviewScoreBelow, d.reviewScoreBelow),
    pileupWindowDays: num(parsed.pileupWindowDays, d.pileupWindowDays),
    pileupMinTasks: num(parsed.pileupMinTasks, d.pileupMinTasks),
    pileupUntouchedSharePct: parsed.pileupUntouchedShare != null ? round(num(parsed.pileupUntouchedShare, 0.6) * 100) : d.pileupUntouchedSharePct,
    pileupRedSharePct: parsed.pileupRedShare != null ? round(num(parsed.pileupRedShare, 0.8) * 100) : d.pileupRedSharePct,
    goalDeclinePp: num(parsed.goalDeclinePp, d.goalDeclinePp),
    goalDeclineMinN: num(parsed.goalDeclineMinN, d.goalDeclineMinN),
    goalDeclineMinCoveragePct: parsed.goalDeclineMinCoverage != null ? round(num(parsed.goalDeclineMinCoverage, 0.8) * 100) : d.goalDeclineMinCoveragePct,
    reviewGapT: num(parsed.reviewGapT, d.reviewGapT),
    deviationAbs: num(parsed.deviationAbs, d.deviationAbs),
    deviationManagerMinN: num(parsed.deviationManagerMinN, d.deviationManagerMinN),
    deviationPeerMinN: num(parsed.deviationPeerMinN, d.deviationPeerMinN),
    deviationMinCoveragePct: parsed.deviationMinCoverage != null ? round(num(parsed.deviationMinCoverage, 0.8) * 100) : d.deviationMinCoveragePct,
    competencyGapPeriods: num(parsed.competencyGapPeriods, d.competencyGapPeriods),
  };
}

export function insightRulesValid(v) {
  return v.overdueTaskSharePct > 0 && v.overdueTaskSharePct <= 100
    && v.overdueAssigneeSharePct > 0 && v.overdueAssigneeSharePct <= 100
    && Number.isInteger(v.overdueMinTasks) && v.overdueMinTasks >= 1 && v.overdueMinTasks <= 100000
    && v.slowdownIncreasePct > 0 && v.slowdownIncreasePct <= 900
    && Number.isInteger(v.slowdownWindowDays) && v.slowdownWindowDays >= 1 && v.slowdownWindowDays <= 90
    && Number.isInteger(v.slowdownMinN) && v.slowdownMinN >= 1 && v.slowdownMinN <= 100000
    && v.reviewScoreBelow >= 0 && v.reviewScoreBelow <= 100
    && Number.isInteger(v.pileupWindowDays) && v.pileupWindowDays >= 1 && v.pileupWindowDays <= 30
    && Number.isInteger(v.pileupMinTasks) && v.pileupMinTasks >= 1 && v.pileupMinTasks <= 100000
    && v.pileupUntouchedSharePct > 0 && v.pileupUntouchedSharePct <= 100
    && v.pileupRedSharePct > 0 && v.pileupRedSharePct <= 100
    && v.pileupRedSharePct >= v.pileupUntouchedSharePct
    && v.goalDeclinePp > 0 && v.goalDeclinePp <= 100
    && Number.isInteger(v.goalDeclineMinN) && v.goalDeclineMinN >= 1 && v.goalDeclineMinN <= 100000
    && v.goalDeclineMinCoveragePct > 0 && v.goalDeclineMinCoveragePct <= 100
    && v.reviewGapT > 0 && v.reviewGapT <= 4
    && v.deviationAbs > 0 && v.deviationAbs <= 4
    && Number.isInteger(v.deviationManagerMinN) && v.deviationManagerMinN >= 1 && v.deviationManagerMinN <= 100000
    && Number.isInteger(v.deviationPeerMinN) && v.deviationPeerMinN >= 1 && v.deviationPeerMinN <= 100000
    && v.deviationMinCoveragePct > 0 && v.deviationMinCoveragePct <= 100
    && Number.isInteger(v.competencyGapPeriods) && v.competencyGapPeriods >= 2 && v.competencyGapPeriods <= 6;
}

export function insightRulesToJson(v) {
  const d = INSIGHT_RULE_DEFAULTS;
  const isDefault = Object.keys(d).every((k) => Number(v[k]) === d[k]);
  if (isDefault) return null;
  return JSON.stringify({
    overdueTaskShare: round(Number(v.overdueTaskSharePct) / 100),
    overdueAssigneeShare: round(Number(v.overdueAssigneeSharePct) / 100),
    overdueMinTasks: Number(v.overdueMinTasks),
    slowdownRatio: round(1 + Number(v.slowdownIncreasePct) / 100),
    slowdownWindowDays: Number(v.slowdownWindowDays),
    slowdownMinN: Number(v.slowdownMinN),
    reviewScoreBelow: Number(v.reviewScoreBelow),
    pileupWindowDays: Number(v.pileupWindowDays),
    pileupMinTasks: Number(v.pileupMinTasks),
    pileupUntouchedShare: round(Number(v.pileupUntouchedSharePct) / 100),
    pileupRedShare: round(Number(v.pileupRedSharePct) / 100),
    goalDeclinePp: Number(v.goalDeclinePp),
    goalDeclineMinN: Number(v.goalDeclineMinN),
    goalDeclineMinCoverage: round(Number(v.goalDeclineMinCoveragePct) / 100),
    reviewGapT: Number(v.reviewGapT),
    deviationAbs: Number(v.deviationAbs),
    deviationManagerMinN: Number(v.deviationManagerMinN),
    deviationPeerMinN: Number(v.deviationPeerMinN),
    deviationMinCoverage: round(Number(v.deviationMinCoveragePct) / 100),
    competencyGapPeriods: Number(v.competencyGapPeriods),
  });
}
